(() => {
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const setup = (root = document) => {
    root.querySelectorAll('.mv-solar-editorial video').forEach(video => {
      if (video.dataset.solarReady) return;
      video.dataset.solarReady = 'true';
      video.controls = false;
      video.muted = true;
      let visible = false;
      const update = () => {
        if (visible && !document.hidden && !reducedMotion.matches) video.play().catch(() => {});
        else video.pause();
      };
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        update();
      }, {threshold: .4});
      observer.observe(video);
      document.addEventListener('visibilitychange', update);
      reducedMotion.addEventListener('change', update);
    });
  };
  const ready = () => {
    setup();
    const container = document.getElementById('ProductGridContainer');
    if (container) new MutationObserver(() => setup(container)).observe(container, {childList:true, subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();

/* Warm an intended collection navigation without intercepting clicks. */
(() => {
 const connection = navigator.connection;
 if(connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;
 const seen = new Set();
 const warm = event => {
  const a = event.target.closest?.('header a[href],header-drawer a[href],.header-wrapper a[href],.menu-drawer a[href]');
  if(!a) return;
  const url = new URL(a.href, location.href);
  if(url.origin !== location.origin || !url.pathname.includes('/collections/') || url.pathname === location.pathname || seen.has(url.href) || seen.size >= 3) return;
  seen.add(url.href);
  const link = document.createElement('link');link.rel='prefetch';link.as='document';link.href=url.href;document.head.appendChild(link);
 };
 document.addEventListener('pointerover', warm, {passive:true});
 document.addEventListener('focusin', warm);
 document.addEventListener('touchstart', warm, {passive:true});
})();
